import React from 'react';
import { useAuth } from './AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  requireRoles?: Array<'admin' | 'manager' | 'tenant'>;
  fallback?: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ 
  children, 
  requireRoles, 
  fallback 
}) => {
  const { isAuthenticated, hasRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="ah-shell">
        <div className="ah-panel" style={{ maxWidth: 400, margin: '10vh auto' }}>
          <div className="ah-card" style={{ textAlign: 'center' }}>
            <div>Loading...</div>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // User not logged in, AuthProvider will handle showing login
    return null;
  }

  if (requireRoles && !hasRole(...requireRoles)) {
    return fallback || (
      <div className="ah-shell">
        <div className="ah-panel" style={{ maxWidth: 400, margin: '10vh auto' }}>
          <div className="ah-card" style={{ textAlign: 'center' }}>
            <h2>Access Denied</h2>
            <p>You don't have permission to access this page.</p>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default PrivateRoute;